<h3 class="mb-2 text-xl">Network</h3>

<p class="my-2"><strong>Quality</strong>: {{ mos() | number: '1.0-1' }}</p>
<p class="my-2"><strong>Average ping</strong> : {{ ping().latencyMs | number: '1.0-2' }} ms</p>
<p class="my-2"><strong>Minimum ping</strong> : {{ ping().min | number: '1.0-2' }} ms</p>
<p class="my-2"><strong>Maximum Ping</strong> : {{ ping().max | number: '1.0-2' }} ms</p>
<p class="my-2"><strong>Jitter</strong> : {{ ping().jitter | number: '1.0-2' }} ms</p>
<p class="my-2"><strong>Downstream flow</strong> : {{ download().bytesPerSecond | toMbps }} MBps</p>
<p class="my-2"><strong>Upstream flow</strong> : {{ upload().bytesPerSecond | toMbps }} MBps</p>
